/** @format */

'use strict';

angular
	.module('emsApp')
	.controller('DocumentDetailController', function($scope, $rootScope, $stateParams, $state, entity, DocumentDownloadService) {
		$scope.document = entity;
		$scope.objectName = 'Document';
		$scope.documentId = $stateParams.documentId;

		if (angular.isUndefined($rootScope.documentActiveTab)) {
			//set the default here
			$rootScope.documentActiveTab = 0;
		}

		$scope.goToEditState = function(document) {
			$state.go('document.detail.edit({documentId:document.id, mappedBy:mappedBy, mappedById:mappedById})');
		};

		// by broadcasting this event from an edit dialog the model is refreshed
		$rootScope.$on('emsApp:documentUpdate', function(event, result) {
			$scope.document = result;
		});

		$scope.download = function(id) {
			DocumentDownloadService(id);
		};
	});
